import React, { useEffect, useState } from "react";
import { publicApi } from "../../utils/publicApi";
import SiteHeader from "../../components/SiteHeader";
import SiteFooter from "../../components/SiteFooter";
import "./PublicCms.css";

const initials = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0]?.[0] || "A").toUpperCase();
};

const PublicTestimonials = () => {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Testimonials — AlphaXCloud";
    (async () => {
      try {
        const res = await publicApi({ url: "admin/get-all" });
        if (res.success) setRows(res.data || []);
        else setError(res.msg || "Could not load testimonials");
      } catch {
        setError("Could not load testimonials");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="public-cms testi-page site-theme">
      <SiteHeader />

      <main className="testi-main">
        <header className="testi-hero">
          <p className="testi-eyebrow">Voices from the community</p>
          <h1>Stories from teams who message with care</h1>
          <p className="testi-lead">
            Quiet confidence from operators, founders, and support leads who run WhatsApp
            at scale with AlphaXCloud.
          </p>
        </header>

        {loading ? <p className="public-cms-muted testi-status">Loading…</p> : null}
        {error ? <div className="public-cms-error">{error}</div> : null}

        {!loading && !error && rows.length === 0 ? (
          <p className="public-cms-muted testi-status">
            No testimonials yet. Add some in Admin → Testimonials.
          </p>
        ) : null}

        <div className="testi-gallery">
          {rows.map((item, i) => (
            <article
              key={item.id}
              className={`testi-card ${i % 3 === 1 ? "testi-card-offset" : ""}`}
              style={{ animationDelay: `${Math.min(i, 8) * 0.08}s` }}
            >
              <span className="testi-mark" aria-hidden="true">
                “
              </span>
              <p className="testi-quote">{item.description}</p>
              <footer className="testi-person">
                <span className="testi-avatar" aria-hidden="true">
                  {initials(item.name)}
                </span>
                <span>
                  <strong>{item.name}</strong>
                  {item.position ? <em>{item.position}</em> : null}
                </span>
              </footer>
            </article>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default PublicTestimonials;
